export enum SolutionUserRole {
  Owner = 'owner',
  User = 'user',
}

export enum SolutionUserNotificationPreferences {
  Email = 1,
  SMS = 2,
  Whatsapp = 3,
}

export type SolutionUserItem = {
  userId: string;
  role: SolutionUserRole;
  phoneNumber: string;
  countryCode: string;
  mobileNumber: string;
  notificationPreference: any[];
  groupIds?: string[];
  siteIds?: string[];
};

export enum SolutionUserItemField {
  Email = 'userId',
  Role = 'role',
  PhoneNumber = 'phoneNumber',
  CountryCode = 'countryCode',
  MobileNumber = 'mobileNumber',
  NotificationPreference = 'notificationPreference',
  NotificationPreferList = 'notificationPreferList',
  GroupIds = 'groupIds',
  SiteIds = 'siteIds',
}

export enum SolutionUsersType {
  Users = 'users',
  Groups = 'groups',
}

export enum SolutionGroupItemField {
  Name = 'name',
  Description = 'description',
  CreatedBy = 'createdBy',
  CreatedAt = 'createdAt',
}

export type SolutionGroupItem = {
  id: string;
  solutionId: string;
  name: string;
  description?: string;
  createdBy: string;
  createdAt: string;
};
